import { Grid, Typography } from '@mui/material'
import React from 'react'
import { PickingValidateSkuDetail } from '../../../interfaces/Picking/Picking'

interface PickingDiffHeaderProps {
  skuDetails: PickingValidateSkuDetail
  orderCancellationRequest: boolean
  title?: string
}

export const PickingDiffHeader: React.FC<PickingDiffHeaderProps> = ({
  skuDetails,
  orderCancellationRequest,
  title = orderCancellationRequest && 'DEVOLVER STOCK' || 'INFORMAR DIFERENCIAS'
}) => {
  return skuDetails ? (
    <Grid container direction='row' spacing={2}>
      <Grid item xs={12} sm={2} lg={2}>
        <img
          style={{ maxWidth: '80px' }}
          src={
            skuDetails.urlImage
              ? skuDetails.urlImage
              : 'https://via.placeholder.com/150/FF00000/FFFFFF%20?text=SIN IMAGEN'
          }
          alt={skuDetails.name}
        />
      </Grid>
      <Grid item xs={12} sm={10} lg={10} style={{ textAlign: 'center' }}>
        <Typography variant='h5' display='block' gutterBottom>
          {title}
        </Typography>
        <Typography variant='button' display='block' gutterBottom>
          {skuDetails.name}
        </Typography>
        <Typography variant='caption' display='block' gutterBottom>
          {skuDetails.sku}
        </Typography>
      </Grid>
    </Grid>
  ) : (
    <div />
  )
}
